// extracted by mini-css-extract-plugin
export default {"rolesListWrapper":"projectSlotRoles_rolesListWrapper__CW6uY"};